export default "__VITE_ASSET__CnL9yHR7__"